import PropTypes from 'prop-types';
import React from 'react';
import Heatmap from './Heatmap';

const AggregatedHeatMapChart = ({
  id,
  data,
  seriesName,
  currencySymbol,
  exportedCsvHeaderTitle,
  heatmapColorRanges,
  isComparisonEnabled,
  providerData,
}) => (
  <Heatmap
    id={id}
    data={data}
    seriesName={seriesName}
    currencySymbol={currencySymbol}
    exportedCsvHeaderTitle={exportedCsvHeaderTitle}
    heatmapColorRanges={heatmapColorRanges}
    isComparisonEnabled={isComparisonEnabled}
    providerData={providerData}
  />
);

AggregatedHeatMapChart.propTypes = {
  id: PropTypes.string,
  data: PropTypes.any,
  seriesName: PropTypes.string,
  currencySymbol: PropTypes.string,
  exportedCsvHeaderTitle: PropTypes.string,
  heatmapColorRanges: PropTypes.any,
  isComparisonEnabled: PropTypes.string,
  providerData: PropTypes.any,
};

export default AggregatedHeatMapChart;
